// Haptic feedback for the native apps. Every call is a no-op on the web,
// and failures are swallowed so a missing plugin never breaks a tap.

import { isNativeApp } from "./platform";

let _haptics = null;
async function plugin() {
  if (!isNativeApp()) return null;
  if (!_haptics) {
    try {
      _haptics = await import("@capacitor/haptics");
    } catch {
      _haptics = false;
    }
  }
  return _haptics || null;
}

export async function tap(style = "LIGHT") {
  const h = await plugin();
  if (!h) return;
  try { await h.Haptics.impact({ style: h.ImpactStyle[style] || h.ImpactStyle.Light }); } catch { /* ignore */ }
}

export async function notify(type = "SUCCESS") {
  const h = await plugin();
  if (!h) return;
  try { await h.Haptics.notification({ type: h.NotificationType[type] || h.NotificationType.Success }); } catch { /* ignore */ }
}

export async function selection() {
  const h = await plugin();
  if (!h) return;
  try { await h.Haptics.selectionChanged(); } catch { /* ignore */ }
}

// A light tap for every button, link and switch in the app, so each screen
// gets haptics without wiring them up one by one.
const TAPPABLE = 'button, a[href], [role="button"], [role="tab"], [role="menuitem"], [role="switch"], [role="checkbox"], input[type="submit"]';

export function installGlobalTapHaptics() {
  if (!isNativeApp()) return;
  document.addEventListener(
    "pointerdown",
    (e) => {
      const el = e.target?.closest?.(TAPPABLE);
      if (!el || el.disabled || el.getAttribute("aria-disabled") === "true") return;
      tap(el.dataset.haptic === "medium" ? "MEDIUM" : "LIGHT");
    },
    { passive: true, capture: true }
  );
}

// Success and error toasts get a matching notification buzz.
export function installToastHaptics(toast) {
  if (!isNativeApp() || !toast || toast.__haptics) return;
  const wrap = (fn, type) => (...args) => { notify(type); return fn(...args); };
  toast.success = wrap(toast.success, "SUCCESS");
  toast.error = wrap(toast.error, "ERROR");
  toast.warning = wrap(toast.warning, "WARNING");
  toast.__haptics = true;
}
